import { useEffect, useState } from 'react';

export default function Footer() {
  const [year] = useState(new Date().getFullYear());

  return (
    <footer className="bg-background-100 py-14">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-bubble-chart-fill text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-900">
                嘿咻嘿咻<span className="text-primary-600">漫画</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              一个围绕《嘿咻嘿咻漫画》的剧情解析与追更讨论社区。看懂剧情、聊透角色、一起把结局真相拼出来。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-foreground-900">内容导航</h3>
            <ul className="mt-4 flex flex-col gap-3">
              {[
                { label: '剧情总览', href: '#story' },
                { label: '角色设定', href: '#characters' },
                { label: '剧情解析', href: '#analysis' },
                { label: '人气排行', href: '#rank' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-600 whitespace-nowrap"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-foreground-900">社区</h3>
            <ul className="mt-4 flex flex-col gap-3">
              {[
                { label: '讨论社区', href: '#community' },
                { label: '结局探讨', href: '#ending' },
                { label: '常见问题', href: '#faq' },
                { label: '加入讨论', href: '#contact' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-600 whitespace-nowrap"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-background-300/60 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © {year} 嘿咻嘿咻漫画剧情解析社区 · 剧情解读为社区观点，欢迎理性讨论
          </p>
          <a
            href="mailto:hello@heixiu-story.cn"
            className="inline-flex items-center gap-2 text-xs text-foreground-500 transition-colors hover:text-primary-600"
          >
            <i className="ri-mail-line" />
            hello@heixiu-story.cn
          </a>
        </div>
      </div>
    </footer>
  );
}

export function ScrollTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="返回顶部"
      className={`fixed bottom-6 right-6 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg transition-all duration-300 hover:bg-primary-600 ${
        visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-4 opacity-0'
      }`}
    >
      <i className="ri-arrow-up-line text-xl" />
    </button>
  );
}